// extracted by mini-css-extract-plugin
module.exports =  {"video-player":"video-player--JQkmg","videoPlayer":"video-player--JQkmg"};